import {useField} from 'formik';
import {useMemo, useCallback} from 'react';

import {Option} from 'interfaces';
import {UserSummary} from 'types';

import {UserSelector} from './UserSelector';

type Props = {
    name: string;
    users?: UserSummary[];
    className?: string;
    showEmptyOption?: boolean;
    errorMessage?: string;
    required?: boolean;
    context?: 'user' | 'agent' | 'assistant';
    field?: 'eid' | 'email';
    onChange?: (value: string) => void;
    renderOptions?: (users: UserSummary[]) => (Option<string, string> | Option<number, string>)[]
}

export type UserSelectorFormikProps = Props;

export const UserSelectorFormik: React.FC<Props> = ({name, onChange, ...rest}: Props) => {
    const [field, meta, helpers] = useField(name);

    const hasError = useMemo<boolean>(() => !!meta.error && (meta.touched || !!meta.value) ||
        (meta.touched && !meta.value && rest.required), [meta, rest]);

    const handleChange = useCallback((newValue) => {
        helpers.setValue(newValue);
        onChange?.(newValue);
    }, [helpers, onChange]);

    return (
        <UserSelector
            {...rest}
            {...field}
            value={field.value}
            hasError={hasError}
            errorMessage={hasError ? rest.errorMessage || meta.error : null}
            onChange={handleChange}
        />
    );
};